import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import styles from './LoadingInline.icss'
import that from '../utilities/translationHelper'

class LoadingInline extends React.Component {
	render() {
		return <span className={styles.loadingSurround}><CircularProgress className={styles.loading} size={24} thickness={4} />{this.props.text}</span>
	}
}

LoadingInline.propTypes = {
	text: PropTypes.string
}

LoadingInline.defaultProps = {
	text: that.context.translate('Loading...')
}

LoadingInline.contextTypes = {
	translate: PropTypes.func
}

export default LoadingInline



// WEBPACK FOOTER //
// ./src/components/LoadingInline.jsx